import React from 'react';
import PropTypes from 'prop-types';
import { DetailPanelData } from "../Common/DetailPanel"
import { formatSQLDateTime, FormatDate } from '../../utils';
import A1 from "../Assets/SafetyClassImages/A1.svg"
import A2 from "../Assets/SafetyClassImages/A2.svg"
import A2L from "../Assets/SafetyClassImages/A2L.svg"
import A3 from "../Assets/SafetyClassImages/A3.svg"
import B1 from "../Assets/SafetyClassImages/B1.svg"
import B2 from "../Assets/SafetyClassImages/B2.svg"
import B2L from "../Assets/SafetyClassImages/B2L.svg"
import B3 from "../Assets/SafetyClassImages/B3.svg"
const ApplianceAssetDetails = ({
    data: {
        isAppliance = false,
        assetType = null,
        amps = null,
        voltage = null,
        hertz = null,
        phase = null,
        hermeticallySealed = null,
        systemManagerName = null,
        safetyClassName = null,
        certificationDate = null,
        certificationNotes = null,
        selfContained = null
    } = {}
}) => {
    const getSafetyImage = (SCN) => {
        switch (SCN) {
            case "A1":
                return A1;
            case "A2":
                return A2;
            case "A2L":
                return A2L;
            case "A3":
                return A3;
            case "B1":
                return B1;
            case "B2":
                return B2;
            case "B2L":
                return B2L;
            case "B3":
                return B3;
            default:
                break;
        }
    }
    return (
        <>
            {isAppliance && (
                <>
                    <DetailPanelData id='amps' title="AMPS" data={amps}  />
                    <DetailPanelData id='voltage' title="VOLTAGE" data={voltage}  />
                    <DetailPanelData id='hertz' title="HERTZ" data={hertz}  />
                    <DetailPanelData id='phase' title="PHASE" data={phase}  />
                    <DetailPanelData id='hermeticallySealed' title="HERMETICALLY SEALED" data={hermeticallySealed == true ? 'Yes' : 'No'}  />
                    <DetailPanelData id='systemManagerName' title="SYSTEM MANAGER" data={systemManagerName}  />
                    {
                        assetType == 67 && (
                            <>
                                <DetailPanelData id='certDate' title="CERTIFICATION DATE" data={(certificationDate != null) ? FormatDate(certificationDate) : '-'}  />
                                <DetailPanelData id='certNotes' title="CERTIFICATION NOTES" data={certificationNotes != null ? certificationNotes : '-'}  />
                                <DetailPanelData id='selfContain' title="SELF CONTAINED" data={(selfContained != null && selfContained === true ) ? 'Yes' : 'No'}   />
                            </>
                     )
                    }
                    {
                        safetyClassName != null && (
                            <DetailPanelData id='safetyClass' title="SAFETY CLASS" data={safetyClassName} image={getSafetyImage(safetyClassName)}  />
                      )
                    }
                </>
            )}
        </>
    );
}

ApplianceAssetDetails.propTypes = {
    data: PropTypes.object.isRequired
};

export default ApplianceAssetDetails;